import { Flex, Radio } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H3 } from "src/atoms/typography";
import { Subtitle } from "src/atoms/typography";
import MicSensitivity from "src/modules/station/enums/MicSensitivity";

export default function NoiseSensitivity({ onChange, selected }) {
  const { t } = useTranslation();
  function SensitivitySelector({ id, stringKey }) {
    return (
      <Flex
        as="label"
        mb="8px"
        alignItems="center"
        sx={{
          "&:last-of-type": {
            mb: "0px"
          }
        }}
      >
        <Radio
          value={id}
          isChecked={selected === id}
          onChange={(e) => onChange(e.target.value)}
        />
        <Subtitle ml="15px" color="highEmphasis">
          {t(stringKey)}
        </Subtitle>
      </Flex>
    );
  }

  return (
    <>
      <Flex flexDirection="column">
        <H3 color="highEmphasis" mb="22px">
          {t("noiseSensitivity.heading")}
        </H3>
        <SensitivitySelector {...MicSensitivity.MS_VERY_HIGH} />
        <SensitivitySelector {...MicSensitivity.MS_HIGH} />
        <SensitivitySelector {...MicSensitivity.MS_MEDIUM} />
        <SensitivitySelector {...MicSensitivity.MS_LOW} />
        <SensitivitySelector {...MicSensitivity.MS_VERY_LOW} />
      </Flex>
    </>
  );
}
